// @ts-check

import { customerCareEmail } from '@/core/constants'
import { defineStore } from 'pinia'
import { computed } from 'vue'
import { useStore } from 'vuex'

export const useServiceStore = defineStore('service', () => {
  /** @type {import('vuex').Store<RootState>} */
  const store = useStore()

  const service = computed(() => store.state.app.service)

  const isTmi = computed(() => service.value === 'ukkopro')
  const isKyy = computed(() => service.value === 'tlp')
  const isOy = computed(() => service.value === 'oy')

  const isEntrepreneur = computed(() => isOy.value || isTmi.value)
  const isLightEntrepreneur = computed(() => isKyy.value)

  const serviceCustomerCareEmail = computed(
    () => customerCareEmail[service.value]
  )

  return {
    service,
    isTmi,
    isKyy,
    isOy,
    isEntrepreneur,
    isLightEntrepreneur,
    serviceCustomerCareEmail,
    $reset: () => true
  }
})

export default useServiceStore
